import * as React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { NoMatch } from './routes/nomatch/NoMatch';
import { PublicRoute } from './routing/PublicRoute';
import { ProtectedRoute } from './routing/ProtectedRoute';

// Router documentation:
// Intro: https://www.robinwieruch.de/react-router/
// Authentication: https://www.robinwieruch.de/react-router-authentication/
// Note: <BrowserRouter> requires historyApiFallback in webpack config,
// in order to make the devServer always use index.hmtl

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Sign-in, forgot-password, and reset-password are owned by Keycloak.
            FINS no longer hosts those screens. */}
        {/* Protected routes have a map. */}
        <Route element={<ProtectedRoute/>}>
          <Route path="" element={null}/>
          <Route path="home" element={null}/>
        </Route>
        {/* Nothing matched? */}
        <Route path="*" element={<PublicRoute logoUrl=''><NoMatch/></PublicRoute>}/>
      </Routes>
    </BrowserRouter>
  );
}

export { Router }
